(function($) {
    'use strict';

    var // Selector names
        classHeader = 'l-header',
        classOffCanvas = 'l-off-canvas',
        classCanvas = 'l-canvas',
        classToggleButton = 'btn-off-canvas-toggle',
        classOffCanvasNavRight = 'off-canvas-right',
        classSiteHeaderFixed = 'header-fixed',
        classOffCanvasOverlay = 'l-off-canvas-overlay',
        classOffcanvasTransition = 'slide-over-transition',

        // Modifier classes
        classJsOffCanvasHidden = 'js-l-off-canvas-hide',
        classJsNavIn = 'js-off-canvas-showing',

        // Elements
        toggleBtn = $('.' + classToggleButton),
        offCanvasElement = $('.' + classOffCanvas),
        offCanvasContent = $('.' + classHeader),
        offCanvasOverlay = $('.' + classOffCanvasOverlay),
        offCanvasBody = $('body'),
        offCanvasCanvas = $('.' + classCanvas),

        // Misc
        headerHeight = $('.' + classHeader).outerHeight(),
        docScrollLoc = 0,
        currentLoc = 0,
        focusIndex = 0,
        focusBeforeOffCanvas,
        tapping = false,
        touchStartX,
        touchStartY;

    // Get off canvas transition duration from css
    var offCanvasDuration = $('.' + classOffcanvasTransition).css('transition-duration').replace('s', '') * 1000;

    // Check if is iOS device.
    function isiOS() {
        if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            offCanvasBody.addClass('is-ios');
            return true;
        } else {
            return false;
        }
    }

    // Trap the keyboard to the off canvas elements when off canvas is showing
    function trapKeyboardToOC() {
        var firstTabStop,
            lastTabStop,
            focusableElementsString,
            focusableElements,
            visibleFocusableElements;

        // Remember element that's focused before off canvas is showing
        focusBeforeOffCanvas = $(':focus');

        // Remove logo from tabindex
        $('.l-logo').attr('tabindex', -1);

        // Focusable visible elements
        focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
        focusableElements = $(focusableElementsString, offCanvasElement);

        focusableElements = Array.prototype.slice.call(focusableElements);

        // Only return visible focusable elments
        visibleFocusableElements = focusableElements.filter(function(el) {
            return getComputedStyle(el).visibility === 'visible';
        });

        // Set first and last tab stop elements
        firstTabStop = visibleFocusableElements[0];
        lastTabStop = visibleFocusableElements[visibleFocusableElements.length - 1];

        // Fire trapTabKey
        offCanvasElement.on('keydown', trapTabKey);

        // Tab press send focus to next/previous element
        function trapTabKey(e) {
            if (e.keyCode === 9) {
                if (e.shiftKey) {
                    if (document.activeElement === firstTabStop) {
                        e.preventDefault();
                        lastTabStop.focus();
                    }
                } else {
                    if (document.activeElement === lastTabStop) {
                        e.preventDefault();
                        firstTabStop.focus();
                    }
                }
            }

            //Escape key press
            if (e.keyCode === 27) {
                e.preventDefault();
                toggleOffCanvas('hide');
            }
        }

        // Focus on the off canvas element
        offCanvasElement.focus();
    }


    function toggleOffCanvas(action) {
        docScrollLoc = $(document).scrollTop();

        if (offCanvasBody.hasClass(classJsNavIn) || action === 'undefined' || action === 'hide') { // Close off canvas
            offCanvasBody.removeClass(classJsNavIn);

            // iOS Safari scroll canvas to the original canvas position
            if (isiOS() && offCanvasBody.hasClass(classSiteHeaderFixed)) {
                offCanvasCanvas.removeAttr('style');
                offCanvasBody.animate({
                    scrollTop: currentLoc
                }, 0);
            }

            // After off canvas is hidden
            setTimeout(function() {
                if(!offCanvasBody.hasClass(classJsNavIn)) {
                    offCanvasElement.addClass(classJsOffCanvasHidden);

                    // Syncing aria-expanded attribute on the menu button
                    toggleBtn.each(function(){
                        $(this).attr('aria-expanded', 'false');
                    });
                }
            }, offCanvasDuration);

            focusBeforeOffCanvas.focus();

            // Add logo back to the tabindex
            $('.l-logo').removeAttr('tabindex');

        } else if (!offCanvasBody.hasClass(classJsNavIn) || action === 'show') { // Open off canvas

            offCanvasElement.removeClass(classJsOffCanvasHidden);

            // iOS Safari set location of canvas so the user doesn't lose where they are
            if (isiOS() && offCanvasBody.hasClass(classSiteHeaderFixed)) {
                offCanvasCanvas.css({
                    'top': -(docScrollLoc - headerHeight)
                });
            }

            offCanvasBody.addClass(classJsNavIn);
            currentLoc = docScrollLoc;

            // Syncing aria-expanded attribute on the menu button
            toggleBtn.each(function(){
                $(this).attr('aria-expanded', 'true');
            });

            trapKeyboardToOC();
        }
    }

    // Document ready
    $(document).ready(function() {
        // Build overlay that covers up the page content so it can't be interacted with when off canvas nav is enabled
        $('.l-surround').prepend('<div class="' + classOffCanvasOverlay + '"></div>');

        // Get X location of user touch
        offCanvasBody.bind('touchstart', function(e) {
            touchStartX = e.originalEvent.touches[0].clientX;
        });

        // If user touches and moves a bit, close the hide the off canvas
        offCanvasBody.bind('touchmove', function(e) {
            var touchRight = e.originalEvent.changedTouches[0].clientX;

            if (touchStartX - 80 > touchRight && offCanvasBody.hasClass(classJsNavIn) &&
                !offCanvasBody.hasClass(classOffCanvasNavRight) && tapping !== true) {
                toggleOffCanvas();
            } else if (touchStartX + 80 < touchRight && offCanvasBody.hasClass(classJsNavIn) &&
                offCanvasBody.hasClass(classOffCanvasNavRight) && tapping !== true) {
                toggleOffCanvas();
            }
        });

        offCanvasElement.addClass(classJsOffCanvasHidden);

        // If user clicks (or taps) close the off canvas nav
        $('.' + classToggleButton + ', .' + classOffCanvasOverlay).on('click', function() {
            toggleOffCanvas();
        });
    });
}(jQuery));
